export default "__VITE_ASSET__CnlTRB9M__"